import { useCallback } from 'react'
import { useDialogState } from '@user/utils/useDialogState'

export function useAddContact() {
  const [addContactOpen, onOpen, onCloseAddContact] = useDialogState()

  const onOpenAddContact = useCallback(
    (event: React.MouseEvent<HTMLAnchorElement>) => {
      event.preventDefault()
      onOpen()
    },
    [onOpen],
  )

  return {
    addContactOpen,
    onOpenAddContact,
    onCloseAddContact,
  }
}
